// extracted by mini-css-extract-plugin
module.exports = {"dialogClass":"playVideoDialog_dialogClass_2p8M7"};